import React from 'react'
import { useTranslation } from 'react-i18next';

const CoefficientInfo = ({coefficientObj}) => {

    const { t } =useTranslation();
  return (  
    <div className="p-card">
        <div className="p-card-body">
            <div className="grid">
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('chzName')}</label>
                    <span>{coefficientObj?.coefficientName}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('enName')}</label>
                    <span>{coefficientObj?.coefficientEName}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('commonName')}</label>
                    <span>{coefficientObj?.commonName}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('carbonFootprint')}</label>
                    <span>{coefficientObj?.cfpValue} {coefficientObj?.cfpUnit}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('quantity')}</label>
                    <span>{coefficientObj?.quantity}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('declareUnit')}</label>
                    <span>{coefficientObj?.declareUnit}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('lifeCycleScope')}</label>
                    <span>{coefficientObj?.lifeCycleScope}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('exclusions')}</label>
                    <span style={{whiteSpace:'pre-wrap'}}>{coefficientObj?.excludedItems}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('technicalDes')}</label>
                    <span style={{whiteSpace:'pre-wrap'}}>{coefficientObj?.technicalDescription}</span>
                    
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('areaName')}</label>
                    <span>{coefficientObj?.productionArea}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('validTimeSpan')}</label>
                    <span>{coefficientObj?.inventoryPeriod}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('dataDenerator')}</label>
                    <span style={{whiteSpace:'pre-wrap'}}>{coefficientObj?.activityDataSource}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('emissionCoefficientSources')}</label>
                    <span style={{whiteSpace:'pre-wrap'}}>{coefficientObj.coefficientSource}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('reliability')}</label>
                    <span>{coefficientObj?.reliabilityLevel}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label className="form-label font-bold">{t('integrity')}</label>
                    <span>{coefficientObj?.integrityLevel}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('consultingUnit')}</label>
                    <span>{coefficientObj.consultingAgencyName}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('dataCommissionerUnit')}</label>
                    <span>{coefficientObj.implementingOrganization}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('thirdPartyCertification')}</label>
                    <span>{coefficientObj.verificationStatus}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('announcementYear')}</label>
                    <span>{coefficientObj.announcementYear}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('remark')}</label>
                    <span style={{whiteSpace:'pre-wrap'}}>{coefficientObj?.comment}</span>
                </div>
                <div className="col-12">
                    <label className="form-label font-bold">{t('gwpSources')}</label>
                    <span>{coefficientObj?.gwpSource}</span>
                </div>
            </div>
    
        </div>



    </div>
  )
}

export default CoefficientInfo;